module.exports = __webpack_public_path__ + "static/img/far1.44277d88.png";